import React from 'react';
import { useTranslation } from 'react-i18next';
import { AreaChangeLocation } from '@mafc/icon';
import { Box, Flex } from '@mafc/trolly';

import { IAddress } from 'services/user/types/user.types';
import getFormattedFullAddress from '../../helpers/getFormattedFullAddress';

import COLORS from 'theme/colors';
import * as S from './SingleAddress.style';

interface Props {
  addressDetails: IAddress;
  isLocationCxEnable?: boolean;
}

const SingleAddress: React.FC<Props> = ({ addressDetails, isLocationCxEnable = false }) => {
  const { t } = useTranslation();

  const { addressLabel } = addressDetails;

  const fullAddress = getFormattedFullAddress(addressDetails, isLocationCxEnable);

  return (
    <S.SingleAddress data-sl="mask">
      <Flex alignItems="center">
        <S.IconWapper>
          <AreaChangeLocation size="custom" height="20px" width="20px" fill={COLORS.BLACK} />
        </S.IconWapper>

        <Box ml="2">
          <S.DeliverTo>{t('shipmentLayout.deliveryAddress')}:</S.DeliverTo>

          {!!addressLabel && <S.AddressLabel>{addressLabel}</S.AddressLabel>}
          <Box>{fullAddress}</Box>
        </Box>
      </Flex>
    </S.SingleAddress>
  );
};

export default SingleAddress;
